import React, {createRef} from "react";
import InputRange from "../interface/input-range";

import BreakpointManager from "../../services/breakpoint-manager";

import {SearchForm, getSortOptions, getYearOptions, getMonthOptions, getDayOptions, getFlexibilityOptions, getDurationOptions } from "./form";
import Facet from "../interface/facet";
import SoloToggle from "../solo-toggle";
import AutoComplete from "../interface/autocomplete";
import UiModal from "../interface/ui-modal";
import CruiseDriver from "./cruise-driver";
import Pagination from "../interface/pagination";
import Checkbox from "../interface/checkbox";
import Panel from "../interface/panel";
import Switch from "../interface/switch";
import Filter from "../interface/filter";
import Scrollable from "../interface/scrollable";

import Pill from "../interface/pill";
import {ordinalSuffix} from "../../utilities";

export default class SearchTemplateFull extends React.Component {
    constructor(props) {
        super(props);

        const { topDestinations, ...rest } = this.props.searchParams;

        this.BreakpointManager = new BreakpointManager();
        this.eventManager = app.eventManager;

        this.eventManager.createEvent('cruise.search', "Cruise Search");
        this.state = {
            solo: this.props.solo,
            modal: '',
            grid: this.props.grid||false,
            open: false,
            breakpoints: this.BreakpointManager.getActiveBreakPoint(),
            isMobile: this.BreakpointManager.getActiveBreakPoint().indexOf("md_down") >= 0,
            priceRange: {min: this.props.searchParams.minValue||1 ,max: this.props.searchParams.maxValue||20000},
            searchParams: rest,
            showSearchParams: false
        }

        this.formRef = createRef();
    }

    componentDidMount(){
        this.BreakpointManager.onChange( this.onWindowResize );
    };

    getConfig = () => {
        let configObject = {
            submit: {
                'renderMethod': this.renderSubmit
            },
            reset: {
                'renderMethod': this.renderReset
            },
            page: {
                'renderMethod': this.renderPagination
            },
            total: {
                'renderMethod': this.renderTotal
            },
            results: {
                'renderMethod': this.renderResults,
            },
            sortBy: {
                'renderMethod': this.renderSort,
                'title': 'Sort By',
                'modalClass': 'select',
                'type': Filter,
                'closeModalOnly': false,
                'props': {
                    'className': 'select column-count-1 in-modal',
                    'choices': getSortOptions(),
                    'filterable': false,
                }
            },
            places: {
                'renderMethod': this.renderModal,
                'type': AutoComplete,
                'title': 'Destination',
                'placeholder': 'Enter destination(s)',
                'iconClass' : 'fa fa-pin',
                'props': {
                    'renderAdditionalContent': this.renderPlacesByAnd,
                    'className': 'in-modal',
                    'label': 'Where would you like to go?',
                    'placeholder': 'Enter destination(s)',
                    'endpoint':'/api/cruise-search/places',
                    'defaultLabel': 'Our Top Destinations',
                    'searchLabel': 'Found Destinations',
                    'groupedOptions': true,
                    'defaultOptions': {
                        '0':'Caribbean',
                        '1':'Norway',
                        '2':'Baltic and Scandinavia',
                        '3':'Mediterranean',
                        '4':'Canary Islands',
                        '6':'Australia',
                        '7':'Canada',
                        '8':'Danube River Cruises',
                    }
                }
            },
            placesByAnd: {
                'renderMethod': this.renderCheck,
                'type': Checkbox,
                'props': {
                    'label': 'Only show cruises that include all the above',
                    'className': 'small m-top-lg'
                }
            },
            departureYear: {
                'renderMethod': this.renderModal,
                'type': Facet,
                'iconClass' : 'fa fa-calendar-alt',
                'title': 'Year',
                'placeholder': 'Year',
                'props': {
                    'className': 'in-modal',
                    'filterable': false,
                    'label': 'Select one or more year(s)',
                    'placeholder': 'Select years',
                    'choices': getYearOptions(),
                }
            },
            departureMonth: {
                'renderMethod': this.renderModal,

                'type': Facet,
                'iconClass' : 'fa fa-calendar-alt',
                'title': 'Month',
                'placeholder': 'Month',
                'props': {
                    'className': 'in-modal',
                    'filterable': false,
                    'label': 'Select one or more month(s)',
                    'placeholder': 'Select months',
                    'choices': getMonthOptions(),
                }
            },
            departureDay: {
                'renderMethod': this.renderDays,
                'title': 'Day',
                'placeholder': 'Day',
                'iconClass' : 'fa fa-calendar-alt',
                'modalClass': 'relative-width',
                'type': Facet,
                'props': {
                    'className': 'in-modal column-count-1',
                    'filterable': false,
                    'choices': getDayOptions(),
                    'label': 'Select day(s)',
                    'placeholder': 'Select days',
                }
            },
            departureFlexibility: {
                'renderMethod': this.renderFlexibility,
                'type': Filter,
                'iconClass' : 'fa fa-exchange',
                'title': 'Flexibility',
                'placeholder': 'Flexibility',
                'props': {
                    'className': 'in-modal',
                    'label': 'How flexible is your departure?',
                    'filterable': false,
                    'placeholder': 'Flexibility',
                }
            },
            duration: {
                'renderMethod': this.renderDuration,
                'type': Filter,
                'iconClass' : 'fa fa-clock',
                'title': 'Duration',
                'placeholder': 'Duration',
                'props': {
                    'className': 'in-modal',
                    'label': 'Select cruise duration?',
                    'placeholder': 'duration',
                    'choices': getDurationOptions(),
                }
            },
            departsUk: {
                'renderMethod': this.renderCheck,
                'props': {
                    'label': 'Sail from a UK port?'
                }
            },

            lineName: {
                'renderMethod': this.renderFacet,
                'type': Facet,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Cruise lines',
                    'placeholder': 'Select cruise line',
                }
            },
            shipName: {
                'renderMethod': this.renderFacet,
                'type': Facet,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Cruise Ships',
                    'placeholder': 'Select cruise ship'
                }
            },
            categories: {
                'renderMethod': this.renderFacet,
                'type': Facet,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Cruise Types',
                    'placeholder': 'Select cruise type'
                }
            },
            departurePort: {
                'renderMethod': this.renderFacet,
                'type': Facet,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Sailing from',
                    'placeholder': 'Enter departure port'
                }
            },
            priceRange: {
                'renderMethod': this.renderPriceRangeWrapper,
                'label': 'Refine price',
            },
            codeToCruiseIds: {
                'renderMethod': this.renderFacet,
                'type': AutoComplete,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Cruise ID?',
                    'placeholder': 'Code to cruise Id',
                    'endpoint':'/api/cruise-search/autocomplete/externalId',
                    'defaultLabel': '',
                    'searchLabel': 'Found Cruise codes',
                    'defaultOptions': {},
                }
            },
            voyageCodes: {
                'renderMethod': this.renderFacet,
                'type': AutoComplete,
                'props': {
                    'className': 'column-count-1',
                    'label': 'Voyage Code?',
                    'placeholder': 'Voyage Code',
                    'endpoint':'/api/cruise-search/autocomplete/voyageCode',
                    'defaultLabel': '',
                    'searchLabel': 'Found Voyages',
                    'defaultOptions': {},
                }
            },
            searchParams: {
                'renderMethod': this.renderSearchParams
            },
        };

        if (this.props.searchParams.topDestinations) {
            const topDestinations = {...this.props.searchParams.topDestinations.split(',').map(dest => dest.trim())};
            if (topDestinations) configObject.places.props.defaultOptions = topDestinations;
        }

        return configObject;
    };

    getMobileConfig = () => { return {
        lineName: {
            'renderMethod': this.renderModal,
            'type': Facet,
            'title': 'Lines',
            'label': 'Cruise lines',
            'iconClass' : 'fa fa-ship',
            'placeholder': 'Select cruise line',
            'props': {
                'className': 'modal',
                'label': 'Please select cruise lines?',
                'placeholder': 'Search cruise lines',
            }

        },
        shipName: {
            'renderMethod': this.renderModal,
            'type': Facet,
            'title': 'Ships',
            'label': 'Cruise Ships',
            'iconClass' : 'fa fa-ship',
            'placeholder': 'Select cruise ship',
            'props': {
                'className': 'modal',
                'label': 'Please select cruise ships?',
                'placeholder': 'Enter cruise ships',
            }
        },
        categories: {
            'renderMethod': this.renderModal,
            'type': Facet,
            'title': 'Types',
            'label': 'Cruise Types',
            'iconClass' : 'fa fa-ship',
            'placeholder': 'Select cruise type',
            'props': {
                'className': 'modal',
                'label': 'Please select cruise types?',
                'placeholder': 'Enter cruise types',
            }
        },
        departurePort: {
            'renderMethod': this.renderModal,
            'type': Facet,
            'title': 'Ports',
            'label': 'Where would you like to sail from',
            'placeholder': 'Enter departure port',
            'iconClass' : 'fa fa-location-arrow',
            'props': {
                'className': 'modal',
                'label': 'Please select departure ports?',
                'placeholder': 'Search departure port',
            }
        },
        codeToCruiseIds: {
            'renderMethod': this.renderModal,
            'type': AutoComplete,
            'label': 'Cruise Code',
            'placeholder': 'Enter c2c Id',
            'props': {
                'className': 'in-modal',
                'label': 'Cruise ID?',
                'placeholder': 'Code to cruise Id',
                'endpoint': '/api/cruise-search/autocomplete/externalId',
                'defaultLabel': '',
                'defaultOptions': {},
            }
        },
        voyageCodes: {
            'renderMethod': this.renderModal,
            'type': AutoComplete,
            'label': 'Cruise Code',
            'placeholder': 'Enter Voyage Code',
            'props': {
                'className': 'in-modal',
                'label': 'Voyage Code?',
                'placeholder': 'Voyage Code',
                'endpoint': '/api/cruise-search/autocomplete/voyageCode',
                'defaultLabel': '',
                'defaultOptions': {},
            }
        },
        priceRange: {
            'renderMethod': this.renderPriceRangeComponent,
            'label': 'Refine price',
        },
    }};

    onWindowResize = (breakpoints) => {
        if(this.state.breakpoints.join('-') !== breakpoints.join('-')) {
            document.body.classList.remove('no-scroll-md-down');
            this.setState({
                open: false,
                modal: '',
                breakpoints: breakpoints,
                isMobile: (breakpoints.indexOf("md_down") >= 0)
            })
        }
    };

    onWindowPopstate = (searchParams) => {
        this.setState({
            priceRange: {
                min: searchParams.minValue||0,
                max: searchParams.maxValue||20000
            }
        });
    };

    handleChange = (formState) => {
        if (typeof ictcc === 'function') ictcc();
        this.eventManager.triggerEvent('cruise.search', {
            "numberOfResults": parseInt(formState.numResults, 10),
            "searchTerm": formState.search_query
        });

        this.setState({solo: formState.searchParams.solo});
    }

    onResetSearch = (callback) => {
        this.setState({ priceRange: { min: 0, max: 20000 } }, callback());
        if (this.props.resetRedirectUrl) window.location.href = this.props.resetRedirectUrl;
    };

    openSearch = () => {
        this.setState({open: true});
        document.body.classList.add('no-scroll-md-down');
    };

    closeSearch = () => {
        this.setState({open: false});
        document.body.classList.remove('no-scroll-md-down');
    };


    openField = (propertyPath) => {
        this.setState({modal: propertyPath});
    };

    closeField = (currentOnly) => {
        this.setState({open: currentOnly, modal: ''});
    };

    toggleField = (propertyPath) => {
        let modal = this.state.modal === propertyPath ? '' : propertyPath;
        this.setState({modal: modal});
    };

    toggleShowSearchParams = () => {
        let showSearchParams = this.state.showSearchParams;
        this.setState({showSearchParams: !showSearchParams});
    };

    renderReset = (propertyPath, form, config) => {
        return (<p className="full-search--reset" onClick={ () => this.onResetSearch( form.resetSearch ) }><span className="hide-for-large">clear</span> <span className="show-for-large">Reset search<i className="icn icn-refresh"/></span></p>);
    };

    renderTotal = (propertyPath, form, config) => {
        return (
            <span>{form.state.pager ? form.state.pager.numResults : ''}</span>
        );
    };

    renderPagination = (propertyPath, form, config) => {
        return (
            <Pagination onChange={ value => form.onFieldUpdate(propertyPath, value)} currentPage={ form.state.pager.curPage } totalPages={ form.state.pager.totalPages } pagesToShow={3} />
        );
    };

    renderPlacesByAnd = () => {
        const formField = this.formRef.current
          .getComponents().placesByAnd;

        return (<>{ React.createElement( formField.type, formField.props )}</>);
    }

    renderPriceRangeWrapper = (propertyPath, form, config) => {
        return (
            <Panel>
                <div className="facet">
                    <div className="facet--header show-for-large">
                        <h6 className="facet--heading">{ config.label }</h6>
                        <span className="facet--clear" onClick={ () => {
                            this.setState({priceRange: {min: 0, max: 20000} }, () => {
                                form.onFieldUpdate('minValue', 0);
                                form.onFieldUpdate('maxValue', 20000)
                            }) }
                        }>Clear</span>
                    </div>

                    { this.renderPriceRangeComponent(propertyPath, form, config) }
                    <br/>
                </div>
            </Panel>
        );
    };

    renderPriceRangeComponent = (propertyPath, form, config) => {
        let minLabel = parseInt(this.state.priceRange.min) > 1 ? `Min £${  this.state.priceRange.min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }pp` : `No Minimum`;
        let maxLabel = parseInt(this.state.priceRange.max) < 20000 ? `Max £${  this.state.priceRange.max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }pp` : `No Maximum`;
        let values = [this.state.priceRange.min, this.state.priceRange.max];
        return (
            <InputRange step={100} min={0} max={20000} values={ values } minLabel={minLabel} maxLabel={maxLabel}
                onChange={ (value) => {
                    this.setState({ priceRange: {min: value[0], max: value[1]} });
                }}
                onFinalChange={ (value) => {
                    form.onFieldUpdate('minValue', value[0] > 1 ? value[0] : null);
                    form.setState(prevState => ({
                        searchParams: {
                            ...prevState.searchParams,
                            maxValue: value[1] < 20000 ? value[1] : null
                        }
                    }), () => form.handleChange(true));
                }}
            />
        );
    };

    renderCheck = (propertyPath, form, config) => {
        return (<Checkbox className={config.props.className} label={ config.props.label } checked={ form.state.searchParams[propertyPath]} onChange={ (value) => { form.onFieldUpdate(propertyPath, value) }}/>);
    };

    renderFlexibility = (propertyPath, form, config) => {
        config.props.choices = getFlexibilityOptions();
        config.disabled = true;
        if(form.state.searchParams.departureYear && form.state.searchParams.departureMonth && form.state.searchParams.departureDay) config.disabled = false;

        return this.renderModal(propertyPath,form, config);
    };

    renderDisabledModal = (propertyPath, form, config) => {
        return ( <div className="search-field--input disabled">
            { config.iconClass && <i className={config.iconClass} /> } { config.placeholder }
        </div> )
    };

    renderDuration = (propertyPath, form, config) => {
        config.props.other  = () =>
            <div className="facet--other">
                <h6 className="facet--heading mt-2 mb-2">please specify your preferred cruise duration</h6>
                <div className="search-field">
                    <p className="search-field--label">Nights</p>
                    <div className="search-field--group">
                        <input value={ form.state.searchParams.minNights } onChange={ (e) => form.onFieldUpdate('minNights', e.target.value ) } type="text"/>
                        <span className="pl-3 pr-3"> to </span>
                        <input value={ form.state.searchParams.maxNights } onChange={ (e) => form.onFieldUpdate('maxNights', e.target.value ) } type="text"/>
                    </div>
                </div>
            </div>;

        return this.renderModal(propertyPath,form, config);
    };

    renderDays = (propertyPath, form, config) => {
        let month = 0;
        let year = form.state.searchParams.departureYear ? form.state.searchParams.departureYear[0] : 0;

        if(form.state.searchParams.departureMonth) {
            let monthIndex = Date.month_names_short.indexOf(form.state.searchParams.departureMonth[0]) + 1;
            month = monthIndex >= 0 ? monthIndex : 0
        }

        config.props.choices = getDayOptions(month, year);
        return this.renderModal(propertyPath, form, config );
    };

    renderModal = (propertyPath, form, config) => {
        if("disabled" in config && config.disabled === true) return this.renderDisabledModal(propertyPath, form, config);
        let props = {
            value: form.state.searchParams[propertyPath]||null,
            data: form.state.facets[propertyPath],
            'onUpdate': (items) => { form.onFieldUpdate(propertyPath, items) },
            ...config.props
        };

        let placeholder = config.placeholder;
        if(form.state.searchParams[propertyPath] ) {
            if (typeof form.state.searchParams[propertyPath] === 'object') {
                placeholder = (config.props.choices ? form.state.searchParams[propertyPath].map((item) => config.props.choices[item]) : form.state.searchParams[propertyPath]).join(', ');
            }

            if (typeof form.state.searchParams[propertyPath] === 'string') {
                placeholder = form.state.searchParams[propertyPath];
            }
        }

        return (<>
            <div
                className={this.state.modal === propertyPath ? "search-field--input active": "search-field--input" }
                onClick={ (e) => {
                    e.stopPropagation();
                    this.openField(propertyPath) }
            }
            >
                { config.iconClass && <i className={config.iconClass} /> } { placeholder || config.placeholder }
            </div>

            <UiModal
                showHeader={true}
                title={ config.title }
                modalClassName={config.modalClass}
                open={ this.state.modal === propertyPath }
                onBack={ () => this.closeField('closeModalOnly' in config ? config.closeModalOnly : true) }
                onClose={ () => this.closeField(false) }
            >
                { React.createElement( config.type, props )}
            </UiModal>
        </>);
    };

    renderFacet = (propertyPath, form, config) => {
        let props = {
            data: form.state.facets[propertyPath],
            value: form.state.searchParams[propertyPath]||null,
            'onUpdate': items => { form.onFieldUpdate(propertyPath, items) },
            ...config.props
        };

        return (<Panel>{ React.createElement( config.type, props )}</Panel>);
    };

    renderSort = (propertyPath, form, config) => {
        if("disabled" in config && config.disabled === true) return this.renderDisabledModal(propertyPath, form, config);
        let props = {
            value: form.state.searchParams[propertyPath]||null,
            data: form.state.facets[propertyPath],
            'onUpdate': (items) => {
                this.setState({modal: ''}, form.onFieldUpdate(propertyPath, items));
            },
            ...config.props
        };

        let placeholder = 'default';
        if(form.state.searchParams[propertyPath] && form.state.searchParams[propertyPath].length > 0) placeholder = form.state.searchParams[propertyPath];
        if(this.state.isMobile) placeholder = 'Sort By';

        return (<>
            <div
                className={this.state.modal === propertyPath ? "search-field--input active": "search-field--input" }
                onClick={ (e) => {
                    e.stopPropagation();
                    this.openField(propertyPath)
                }  }
            >
                { config.iconClass && <i className={config.iconClass} /> } { placeholder }
            </div>

            <UiModal
                showHeader={true}
                title={ config.title }
                modalClassName={config.modalClass}
                open={ this.state.modal === propertyPath }
                onBack={ () => this.closeField('closeModalOnly' in config ? config.closeModalOnly : true) }
                onClose={ () => this.closeField(false) }
            >
                { React.createElement( config.type, props )}
            </UiModal>
        </>);
    };

    renderResults = (propertyPath, form, config)=> {
        let resultKeys = Object.keys(form.state.results);

        if( resultKeys.length >= 1 ) return resultKeys.map(item =>
            <div key={ form.state.results[item].id } className={this.state.grid || this.state.isMobile ? 'columns small-12 medium-6' : 'columns small-12'}>
                <CruiseDriver solo={ this.state.solo } grid={ this.state.isMobile ? true : this.state.grid } {...form.state.results[item]} />
            </div>
        );

        return (
            <div className="columns small-12">
                <div className="full-search--no-results">
                    <h2>No Results Found</h2>
                    { this.renderReset(propertyPath, form, config)}
                    <p>Your search criteria returned no results, please reset your search criteria. Alternatively you can view our cruise deals or contact us at <a href="tel:08082394989">0808 239 4989</a> </p>
                    <br />
                    <p>
                        <a className="button margin-sides" href="/customer-service">Contact Us</a>
                        <a className="button secondary white-bg text-black margin-sides" href="/cruise-deals">Cruise Deals</a>
                    </p>
                </div>
            </div>
        )
    };

    renderSearch = (formFields) => {
        return (
            <div className="full-search--cruise-search">
                {this.props.renderHeader ? (
                  <h2>Cruise search</h2>
                ) : (
                  <h1>Cruise search</h1>
                )}
                <hr className="rope"/>

                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Destination </p>
                    { formFields.places}
                </div>
                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Year </p>
                    { formFields.departureYear}
                </div>
                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Month </p>
                    { formFields.departureMonth}
                </div>
                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Day </p>
                    { formFields.departureDay}
                </div>
                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Flexibility </p>
                    { formFields.departureFlexibility}
                </div>
                <div className="position-relative search-field condensed">
                    <p className="search-field--label">Duration </p>
                    { formFields.duration}
                </div>

                <div className="position-relative search-field condensed">
                    {formFields.departsUk}
                </div>

                <div className="position-relative search-field condensed">
                    <p className="search-field--label">View prices as:</p>
                    <SoloToggle checked={this.state.solo} toggleOnly={true}/>
                </div>

                <div className="w-100">
                    <hr className="rope"/>
                    { formFields.reset }
                </div>

            </div>
        )
    };

    renderFilters = (formFields) => {
        return (<>
            { formFields.lineName }
            <br/>
            <br/>
            { formFields.shipName }
            <br/>
            <br/>
            { formFields.categories }
            <br/>
            <br/>
            { formFields.departurePort }
            <br/>
            <br/>
            { formFields.priceRange }
            <br/>
            <br/>
            { formFields.codeToCruiseIds }
            <br/>
            <br/>
            { formFields.voyageCodes }
        </>)
    };

    renderMobileSearch = (formFields) => {
        return (<>
            <h6 className="full-search--modal-heading">Filter your search results </h6>
            { formFields.reset }

            <div className="search-field">
                <p className="search-field--label">Destination </p>
                { formFields.places}
            </div>

            <div className="search-field">
                <p className="search-field--label">Year</p>
                { formFields.departureYear }
            </div>

            <div className="search-field">
                <p className="search-field--label">Month</p>
                { formFields.departureMonth }
            </div>


            <div className="search-field position-relative">
                <p className="search-field--label">Day</p>
                { formFields.departureDay }
            </div>

            <div className="search-field">
                <p className="search-field--label">Flexibility</p>
                { formFields.departureFlexibility }
            </div>

            <div className="search-field">
                <p className="search-field--label">Duration</p>
                { formFields.duration }
            </div>

            <div className="search-field">
                <p className="search-field--label">Cruise type</p>
                { formFields.categories }
            </div>

            <div className="search-field">
                <p className="search-field--label">Cruise lines</p>
                { formFields.lineName }
            </div>

            <div className="search-field">
                <p className="search-field--label">Cruise ship</p>
                { formFields.shipName }
            </div>

            <div className="search-field condensed">
                {formFields.departsUk}
            </div>

            <div className="search-field">
                <p className="search-field--label">Departure port</p>
                { formFields.departurePort }
            </div>

            <div className="search-field">
                <p className="search-field--label">View prices as</p>
                <SoloToggle checked={this.props.solo} toggleOnly={true}/>
            </div>

            <div className="search-field mt-4">
                <p className="search-field--label">Refine price</p>
                {formFields.priceRange}
            </div>

            <div className="search-field">
                <p className="search-field--label">Cruise ID</p>
                {formFields.codeToCruiseIds}
            </div>

            <div className="search-field">
                <p className="search-field--label">Voyage Code</p>
                {formFields.voyageCodes }
            </div>
        </>)
    };


    renderSearchParams = (propertyPath, form, config) => {
        let removeCallback = (param, value) => { form.onFieldRemoveValue(param, value)  };
        let pills = [];

        // remove topDestinations prop before render
        const { topDestinations, ...filteredSearchParams } = form.state.searchParams;

        Object.keys(filteredSearchParams).forEach((param) => {
            if(param === 'page' || param === 'sortBy' || param === 'placesByAnd' || param === 'cruiseIds' || param === 'promotionIds' || param === 'lastMinute') return;

            let field = form.state.searchParams[param];
            let prefix = param.replace('Name', '').replace('Port','Departure Port').replace('departure', '').replace('Value','').replace('By', '').replace('places','Destination');
            prefix = prefix.charAt(0).toUpperCase() + prefix.slice(1);


            if(field && typeof field === 'object') Object.keys(field).forEach( (key) => {
                let label = field[key];
                if(param === 'departureDay') label = ordinalSuffix(field[key]);
                if(param === 'departureMonth') label = getMonthOptions()[field[key]];

                pills.push(<Pill key={param+'_'+field[key]} label={prefix + ': ' + label} onRemove={() => removeCallback(param, field[key]) } />)
            });

            if(field && typeof field === 'number') pills.push(<Pill key={param+'_'+field} label={prefix + ': ' +field} onRemove={() => removeCallback(param, field) } />);
            if(field && typeof field === 'string') pills.push(<Pill key={param+'_'+field} label={prefix + ': ' +field} onRemove={() => removeCallback(param, field) } />);
        });

        Object.keys(pills).forEach(key => pills[key] === undefined && delete pills[key]);
        return (
            <>
                { this.state.isMobile && !this.state.showSearchParams ? pills.slice(0, 5) : pills }
                { pills.length <= 5 && <div className="pl-2 pr-2"><hr className="rope ml-3 mr-3 hide-for-large" /></div> }
                { pills.length >= 6 && <div className="info-expander--container hide-for-large">
                    <div className={this.state.showSearchParams ? 'info-expander keyline active' : 'info-expander keyline'} onClick={ this.toggleShowSearchParams }>
                       <span className="info-expander--text always-show">Show all search criteria </span><i className="icn icn-angle-down" />
                    </div>
                </div> }

            </>
        );
    };

    renderSearchResults = (formFields) => {
        return(
          <>

            {this.props.renderHeader ? (
              <div style={{width:'100%'}} dangerouslySetInnerHTML={{ __html: this.props.renderHeader }} />
            ) : (
              <ul className="breadcrumbs new show-for-large">
                <li className="breadcrumbs--item"><a className="breadcrumbs--link" href="/">Home</a></li>
                <li className="breadcrumbs--item">Cruise search</li>
              </ul>
            )}

            <p className="full-search--result-count show-for-large">Your search has returned { formFields.total } cruises</p>
            {this.props.showTags && <div className="full-search--search-params show-for-large">{formFields.searchParams}</div> }

            <hr className="show-for-large rope" />


            <div className="full-search--filters-button" onClick={ this.openSearch }> Edit search <i className="fa fa-search" /></div>

            <div className="full-search--sort">
                <span className="label">Sort by:</span> { formFields.sortBy }
            </div>

            <p className="full-search--result-count hide-for-large">Your search has returned { formFields.total } cruises</p>
            {this.props.showTags && <div className="full-search--search-params hide-for-large">
                { formFields.searchParams }
            </div> }

            <div className="full-search--pagination">
                { formFields.page }
            </div>

            <div className="full-search--display-toggle">
                <Switch
                    checked={this.state.grid}
                    onToggle={ value => this.setState({grid: value})  }
                    renderRightLabel={ () => <span>Grid <i className="fa fa-th"></i></span>}
                    renderLeftLabel={ () => <span>List <i className="fa fa-th-list"></i></span>}
                />
            </div>

            <div className="row cruise-driver--equalise-container w-100">
                { formFields.results }
            </div>

            <div className="full-search--bottom-pagination">
                { formFields.page }
            </div>

            {this.props.renderFooter && <div style={{width:'100%'}} dangerouslySetInnerHTML={{ __html: this.props.renderFooter }} />}
          </>
        )
    };

    renderSubmit = (propertyPath, form, config) => {
        return (<a className="ui-modal--apply" href={`/find-your-cruise?${form.state.http_query}`}>SEARCH {form.state.pager ? form.state.pager.numResults : ''} CRUISES <i className="fa fa-search"></i></a>);
    };

    renderSearchFilterFields = (formFields) => {
        if(!this.state.isMobile) return (<>
            <div className="small-12 columns">
                { this.renderSearch(formFields) }
            </div>

            <div className="small-12 show-for-large columns pt-5">
                <h3 className="mb-5">Filter By</h3>
                { this.renderFilters(formFields) }
            </div>
        </>);

        if(this.state.open ) return (<>
            <div ref="modal" className="ui-modal bg-gray">
                <div className="ui-modal--header"><div className="ui-modal--title">Edit search</div></div>
                <div className="ui-modal--close" onClick={ this.closeSearch} ><span>Close</span></div>
                { this.state.modal === '' ? <Scrollable className="full-search--simple-bar ui-modal--simple-bar ui-modal--content">{ this.renderMobileSearch(formFields) }</Scrollable> : this.renderMobileSearch(formFields) }
                { formFields.submit }
            </div>
        </>);

        return (<></>);
    };

    renderTemplate = (formFields) => {
        return (
            <div className="full-search row">
                <div className="small-12 large-3 columns">
                    <div className="row">
                        { this.renderSearchFilterFields(formFields) }
                    </div>
                </div>
                <div className="small-12 large-9 columns full-search--results">
                    { this.renderSearchResults(formFields) }
                </div>
            </div>
        );
    };

    render() {
        let config = this.getConfig();
        if( this.state.isMobile ) config = {...config, ...this.getMobileConfig() };

        return (
            <SearchForm ref={this.formRef} template={ this.renderTemplate } config={ config } searchParams={ this.state.searchParams } onWindowPopstate={ this.onWindowPopstate } onChange={this.handleChange} useAnalytics={true} />
        )
    }
}



